var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard_unselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-dashboard-(black)",
    transform: "translate(-2.000000, -2.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,19.999962 L12,10.000002 L20,10.000002 L20,19.999962 L12,19.999962 Z M2,11.999962 L2,2 L10,2 L10,11.999962 L2,11.999962 Z M8,10.000002 L8,4.000002 L4,4.000002 L4,10.000002 L8,10.000002 Z M2,19.999962 L2,13.999962 L10,13.999962 L10,19.999962 L2,19.999962 Z M4,17.999962 L8,17.999962 L8,15.999962 L4,15.999962 L4,17.999962 Z M14,17.999962 L18,17.999962 L18,11.999962 L14,11.999962 L14,17.999962 Z M12,2 L20,2 L20,8 L12,8 L12,2 Z M14,4.000002 L14,6.000002 L18,6.000002 L18,4.000002 L14,4.000002 Z",
    id: "dashboard_unselected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardUnselected);
export default __webpack_public_path__ + "static/media/dashboard_unselected.a232c4b4a6228d2027f47f7af317c218.svg";
export { ForwardRef as ReactComponent };